/**
 * @pageName ServicePage
 * @slotType site plugin
 */
export type ServicePageParams = { bookingsServiceId: string };
export const SlotIds = {
  slot1: '1c36d1de-3ede-43cf-adb5-4148276ad0a7',
};
